import { render, staticRenderFns } from "./ModalsConfirmDeleteConsultant.vue?vue&type=template&id=1a9c8837&scoped=true"
import script from "./ModalsConfirmDeleteConsultant.vue?vue&type=script&lang=js"
export * from "./ModalsConfirmDeleteConsultant.vue?vue&type=script&lang=js"
import style0 from "./ModalsConfirmDeleteConsultant.vue?vue&type=style&index=0&id=1a9c8837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c8837",
  null
  
)

export default component.exports